<div class="wrapper theme2">

    <div class="block-content">
        <div>
            <app-public-menu></app-public-menu>
            <div class="relative header-slider-wrapper animate animation-duration-1000 animation-ease-out">

                <div class="fadein animation-duration-500 grid container">
                    <div class="text-center relative col-12 slide-text-wrapper">
                        <div class="text-6xl text-white font-bold mb-1 text-gradient">{{'building.title' | translate}}
                        </div>
                        <div class="text-yellow font-bold mb-4 ">{{'building.subtitle' | translate}}</div>

                    </div>
                </div>
                <ng-container *ngIf="!loading && propertyList">
                    <div class="grid justify-content-center m-3 container">
                        <ng-container *ngFor="let property of propertyList">
                            <app-property-card [property]="property" [config]="{type: 'public'}"></app-property-card>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
            <!----><!---->
        </div>
    </div>

    <app-public-footer></app-public-footer>